/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { compose } from 'redux';
import {
    object, array, string, number, func, shape, bool,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';

import AddressBookForm from './Partials/AddressBookForm';
import { verifyScopeExist } from '../../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { withAuth } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

const styles = (theme) =>  ({
    buttonContainer: {
        display: 'block',
        width: '100%',
        textAlign: 'right',
    },
    buttonRootClass: {
        fontSize: '16px',
        display: 'inline-block',
        width: '200px',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        fontWeight: 'normal',
        padding: '2px 10px',
        textTransform: 'none',
        border: `1px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
            color: theme.palette.white,
        },
        [theme.breakpoints.down('xs')]: {
            width: 150,
        },
    },
    btnMyAddressBook: {
        color: '#5F3C86',
        backgroundColor: 'transparent',
        border: 0,
        padding: 0,
        textDecoration: 'underline',
        lineHeight: '19px',
        fontSize: '13px',
        fontWeight: 600,
        cursor: 'pointer',
    },
    ccoNewCalendarBtnMyAddressBook: {
        color: '#000000',
        backgroundColor: 'transparent',
        border: 0,
        padding: 0,
        textDecoration: 'underline',
        lineHeight: '19px',
        fontSize: '13px',
        fontWeight: 600,
        cursor: 'pointer',
        fontFamily: 'Poppins',
    },
    pageLink: {
        cursor: 'pointer',
        borderRadius: '50%',
        padding: '2px 5px',
        border: `1px solid ${theme.palette.black}`,
        margin: '0px 5px',
        backgroundColor: theme.palette.white,
        color: theme.palette.black,
        fontWeight: '500',
    },
    pageLinkSelected: {
        cursor: 'pointer',
        borderRadius: '50%',
        padding: '2px 5px',
        margin: '0px 5px',
        backgroundColor: theme.palette.black,
        color: theme.palette.white,
        fontWeight: '500',
    },
    modalBox: {
        position: 'static',
        padding: '10px 0',
        margin: '10px',
        maxHeight: 'calc(100% - 96px)',
        minHeight: 'calc(100% - 96px)',
        maxWidth: '800px',
        minWidth: '800px',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '90%',
            minWidth: '90%',
            margin: '0 auto',
            paddingTop: 0,
        },
    },
    fixedHeader: {
        width: '780px',
        position: 'fixed',
        margin: '0 10px',
        padding: '0 0 8px',
        borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            position: 'relative',
            margin: 0,
            borderBottom: 'none',
            display: 'block',
        },

    },
    modalHeader: {
        position: 'relative',
        padding: '3px 10px',
        borderBottom: `1px sfffolid ${theme.palette.colorNeutral40}`,
        [theme.breakpoints.down('sm')]: {
            position: 'fixed',
            width: '90%',
            zIndex: 9999,
            background: theme.palette.white,
            borderBottom: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        },
    },
    dialogTitle: {
        width: '100%',
        padding: '5px 0',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        [theme.breakpoints.down('600')]: {
            padding: '5px',
        },
    },
    closeBtn: {
        color: theme.palette.black,
        position: 'absolute',
        right: '10px',
        top: '5px',
        padding: '0',
        margin: '0',
    },
    pageCount: {
        padding: '8px 0',
        fontSize: '12px',
        fontWeight: '700',
        textAlign: 'right',
        color: theme.palette.colorNeutral80,
        [theme.breakpoints.down('sm')]: {
            padding: '20px 0 5px',
        },
    },
    searchTextBox: {
        padding: '0px',
        width: '100%',
    },
    dialogContent: {
        margin: '87px 0 10px 10px',
        overflowY: 'auto',
        width: '780px',
        minWidth: '85%',
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            overflowY: 'visible',
            margin: '0px 0 10px',
            padding: '0 15px',
        },
    },
    rightCol: {
        textAlign: 'right',
    },
    addressItemContent: {
        padding: '0 0 15px',
        margin: '10px 0 15px',
        borderBottom: `1px solid ${theme.palette.colorNeutral40}`,
        [theme.breakpoints.down('sm')]: {
            borderTop: `1px solid ${theme.palette.colorNeutral40}`,
            padding: '15px 0',
            margin: 0,
        },
    },
    btnUseAddress: {
        fontSize: '14px',
        width: '130px',
        margin: '15px 0',
        color: theme.palette.white,
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        border: `1px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        fontWeight: 'normal',
        padding: '2px 10px',
        textTransform: 'none',
        '&:hover, &:focus': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            backgroundColor: theme.palette.white,
        },
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
        },
        [theme.breakpoints.down(375)]: {
            fontSize: '11px',
        },
    },
    btnEditDelete: {
        fontSize: '14px',
        width: '80px',
        margin: '15px 10px 15px 0',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        backgroundColor: theme.palette.white,
        border: `1px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        fontWeight: 'normal',
        padding: '2px 10px',
        textTransform: 'none',
        '&:hover, &:focus': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            backgroundColor: theme.palette.white,
        },
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
            margin: '15px 8px 15px 0',
        },

    },
    title: {
        fontWeight: '700',
        fontSize: '14px',
        margin: '0 0 10px',
        padding: '0',
        color: theme.palette.colorNeutral80,
    },
    infoText: {
        fontWeight: 'normal',
        fontSize: '14px',
        margin: '0',
        padding: '0',
        color: theme.palette.colorNeutral70,
    },
    btnAddAddress: {
        backgroundColor: theme.palette.white,
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        fontSize: '16px',
        fontWight: 'bold',
        textAlign: 'center',
        width: 'auto',
        height: 'auto',
        padding: '0',
        margin: '0',
        display: 'block',
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme.palette.white,
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            fontWeight: 700,
            paddingTop: 14,
        },
    },
    addAdressButton: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '60%',
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            order: 2,
            flexBasis: '60%',
            paddingLeft: 15,
        },
    },
    searchBlock: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            order: 1,
            flexBasis: theme.palette.tiers?.container?.maxWidth?.downSmall,
            marginTop: 48,
            padding: '0 15px',
        },
    },
    pageCountBlock: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '40%',
            width: theme.palette.tiers?.container?.maxWidth?.downSmall,
            order: 2,
            flexBasis: '40%',
            paddingRight: 15,
        },
    },
    addAdressBlock: {
        [theme.breakpoints.down('sm')]: {
            marginTop: 48,
        },
    },
    addressSubHeaderMobile: {
        fontWeight: '800',
        fontSize: '16px',
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    addressSubHeaderMain: {
        display: 'flex',
        alignItems: 'center',
    },
    mobileDividerLine: {
        height: '2px',
        width: '100%',
        background: theme.palette.cms?.primary || theme.palette.colorPrimary,
        marginTop: '5px',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    myAddressBook: {
        fontSize: '16px',
        lineHeight: '20px',
        paddingTop: '24px',
        textUnderlineOffset: '5px',
        textDecorationThickness: '2px',
        color: '#000000',
        backgroundColor: 'transparent',
        '&:hover, &:focus': {
            backgroundColor: 'transparent',
            textDecoration: 'underline',
            textUnderlineOffset: '5px',
            textDecorationThickness: '2px',
            color: '#000000',
        },
    },
    deliveryTitleTop: {
        [theme.breakpoints.down('600')]: {
            '& $myAddressBook': {
                padding: '0px',
                '& .MuiButton-label': {
                    textTransform: 'capitalize',
                },
            },
        },
    },
    plaAddressBook: {
        padding: '0px',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.16px',
        textTransform: 'capitalize',
        '@media screen and (max-width: 600px)': {
            lineHeight: '20px',
            fontSize: '14px',
        },
    },
});

class AddressBookWithPagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openAddressBook: false,
            searchText: '',
            bookEntriesCollection: [],
            bookEntriesResultSet: [],
            contentModalType: 'list',
            addressInfo: [],
        };
    }

    componentDidMount() {
        this.setBookEntries();
    }

    componentDidUpdate(prevProps) {
        const { pageOn, totalAddresses, entries } = this.props;
        const { initialBookEntries, contentModalType } = this.state;
        if (
            prevProps.pageOn !== pageOn
            || prevProps.totalAddresses !== totalAddresses
            || initialBookEntries !== entries
        ) {
            this.setBookEntries();
            if (contentModalType === 'add' || contentModalType === 'edit') {
                this.handleCancelAddressBookForm();
            }
        }
    }

    onHandleSelection = (selectedAddressData) => {
        const { onSelectedAddress } = this.props;
        if (selectedAddressData && selectedAddressData.AddressBookEntryId) {
            onSelectedAddress(selectedAddressData);
        } else {
            onSelectedAddress({});
        }
        this.setState({
            openAddressBook: false,
        });
    }

    onHandlePageChange = (pageNumber) => {
        const { loadAddressBook } = this.props;
        this.setState({
            searchText: '',
        });
        loadAddressBook(pageNumber);
    }

    onHandleChangeAddress = (addressBookEntry) => {
        const { handleChangeAddressBook } = this.props;
        const { contentModalType } = this.state;
        handleChangeAddressBook(addressBookEntry, contentModalType);
        this.setState({
            contentModalType: 'list',
            addressInfo: {},
        });
    }

    setBookEntries = () => {
        const { entries } = this.props;
        const addressList = entries.map((item) => ({
            text: this.getLineAddress(item),
            obj: item,
        }));
        this.setState({
            initialBookEntries: entries,
            bookEntriesCollection: addressList,
            bookEntriesResultSet: addressList,
        });
    }

    getLineAddress = (address) => {
        const profile = address;
        const Addresses = profile?.Addresses?.[0] ?? {};
        let buildAddress = '';
        buildAddress = (profile.FirstName) ? `${buildAddress} ${profile.FirstName}` : buildAddress;
        buildAddress = (profile.LastName) ? `${buildAddress} ${profile.LastName}` : buildAddress;
        buildAddress = (Addresses.AddressLineOne) ? `${buildAddress} ${Addresses.AddressLineOne}` : buildAddress;
        buildAddress = (Addresses.City) ? `${buildAddress} ${Addresses.City}` : buildAddress;
        buildAddress = (Addresses.StateProvince) ? `${buildAddress} ${Addresses.StateProvince}` : buildAddress;
        buildAddress = (Addresses.Country) ? `${buildAddress} ${Addresses.Country}` : buildAddress;
        buildAddress = (Addresses.PostalCode) ? `${buildAddress} ${Addresses.PostalCode}` : buildAddress;
        return buildAddress.trim();
    }

    getNoResultText = () => {
        const { noOfPages, pageOn } = this.props;
        if (noOfPages > 1) {
            return `Address not found in page ${pageOn + 1}`;
        }
        return 'Address not found';
    }

    getAddressList = (entries) => {
        const { classes, handleRemoveAddressBook } = this.props;
        const addressList = entries.map((item) => {
            const profileInfo = item?.obj ?? {};
            const AddressInfo = profileInfo?.Addresses?.[0] ?? {};
            return (
                <Grid key={`addressList${profileInfo.AddressBookEntryId}`} container className={classes.addressItemContent}>
                    <Grid item xs={12}>
                        <p className={classes.title}>{profileInfo.FirstName || ''} {profileInfo.LastName || ''}</p>
                        <p className={classes.infoText}>{AddressInfo.AddressLineOne || ''} {AddressInfo.AddressLineTwo || ''}</p>
                        <p className={classes.infoText}>{AddressInfo.City || ''}, {AddressInfo.StateProvince || ''} {AddressInfo.PostalCode || ''}</p>
                    </Grid>
                    <Grid container>
                        <Grid item xs={7} sm={6}>
                            <Button
                                data-test="checkout-recipient-form-list-savedAddress"
                                classes={{
                                    root: classes.btnEditDelete,
                                }}
                                value={profileInfo.AddressBookEntryId}
                                onClick={() => this.handleEditAddressBook(profileInfo)}
                            >
                                Edit
                            </Button>
                            <Button
                                data-test="checkout-recipient-form-list-savedAddress"
                                classes={{
                                    root: classes.btnEditDelete,
                                }}
                                value={profileInfo.AddressBookEntryId}
                                onClick={() => handleRemoveAddressBook(profileInfo.AddressBookEntryId)}
                            >
                                Delete
                            </Button>
                        </Grid>
                        <Grid item xs={5} sm={6} className={classes.rightCol}>
                            <Button
                                data-test="checkout-recipient-form-list-savedAddress"
                                classes={{
                                    root: classes.btnUseAddress,
                                }}
                                value={profileInfo.AddressBookEntryId}
                                onClick={() => this.onHandleSelection(profileInfo)}
                            >
                                Use this Address
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            );
        });
        if (addressList.length === 0) {
            return (
                <MenuItem
                    classes={{
                        root: classes.menuRootClass,
                    }}
                >
                    { this.getNoResultText() }
                </MenuItem>
            );
        }
        return addressList;
    }

    getPages = (start, end) => new Array(end - start).fill().map((d, i) => i + start);

    getPageLink = () => {
        const { noOfPages, pageOn, classes } = this.props;
        const arrPages = this.getPages(0, noOfPages);
        return arrPages.map((item) => {
            if (pageOn === item) {
                return <span key={`pageLink${item}`} className={classes.pageLinkSelected}>{item + 1}</span>;
            }
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            return <span key={`pageLink${item}`} className={classes.pageLink} onClick={() => { this.onHandlePageChange(item); }}>{item + 1}</span>;
        });
    }

    getEditContent = () => {
        const { addressInfo } = this.state;
        const { classes } = this.props;
        return (
            <Grid container className={classes.addAdressBlock}>
                <AddressBookForm
                    bookAddressValues={addressInfo}
                    handleChangeAddressBook={this.onHandleChangeAddress}
                    handleCancelAddressBookForm={this.handleCancelAddressBookForm}
                />
            </Grid>
        );
    }

    getAddContent = () => {
        const addressInfo = {};
        const { classes } = this.props;
        return (
            <Grid container className={classes.addAdressBlock}>
                <AddressBookForm
                    bookAddressValues={addressInfo}
                    handleChangeAddressBook={this.onHandleChangeAddress}
                    handleCancelAddressBookForm={this.handleCancelAddressBookForm}
                />
            </Grid>
        );
    }

    getContent = () => {
        const { contentModalType, bookEntriesResultSet } = this.state;
        switch (contentModalType) {
            case 'list':
                return this.getAddressList(bookEntriesResultSet);
            case 'edit':
                return this.getEditContent();
            case 'add':
                return this.getAddContent();
            default:
                break;
        }
        return null;
    }

    handleOpenAddressBook = async () => {
        const { isAccessBasedOnScopeEnabled } = this.props;
        if (isAccessBasedOnScopeEnabled) {
            const { auth: { getAccessTokenSafely, loginByRedirect } } = this.props;
            const accesstoken = await getAccessTokenSafely();
            if (verifyScopeExist(accesstoken, 'write:checkout')) {
                this.setState({
                    openAddressBook: true,
                });
            } else {
                await loginByRedirect();
            }
        } else {
            this.setState({
                openAddressBook: true,
            });
        }
    }

    handleSearchTextChange = (event) => {
        const { bookEntriesCollection } = this.state;
        const strSearchText = event.target.value;
        const addressBookSearchResult = bookEntriesCollection.filter((item) => (
            item.text.toLowerCase().includes(strSearchText.toLowerCase())
        ));
        this.setState({
            searchText: event.target.value,
            bookEntriesResultSet: addressBookSearchResult,
        });
    }

    handleCancelAddressBookForm = () => {
        const { loadAddressBook, pageOn } = this.props;
        loadAddressBook(pageOn);
        this.setBookEntries();
        this.setState({
            contentModalType: 'list',
            addressInfo: {},
        });
    }

    handleCloseAddressBook = () => {
        this.setState({
            openAddressBook: false,
            contentModalType: 'list',
            addressInfo: {},
        });
    }

    handleEditAddressBook = (editAddress) => {
        this.setState({
            openAddressBook: true,
            contentModalType: 'edit',
            addressInfo: editAddress,
        });
    }

    handleAddAddressBook = () => {
        this.setState({
            openAddressBook: true,
            contentModalType: 'add',
            addressInfo: {},
        });
    }

    render() {
        const {
            label, name, classes, totalAddresses, pageType, isPdpRedesignEnabled, isCCONewCalenadarEnabled, displayDeliveryCalendar, isPdpDeliveryTopEnabled, isPlaRedesignEnabled,
        } = this.props;
        const { openAddressBook, searchText } = this.state;
        const { contentModalType } = this.state;
        const myAddressBook = isPdpRedesignEnabled ? classes.myAddressBook : '';
        const plaAddressBook = isPlaRedesignEnabled ? classes.plaAddressBook : '';
        return (
            <Grid container>
                <div className={`${classes.buttonContainer} ${isPdpRedesignEnabled && isPdpDeliveryTopEnabled ? classes.deliveryTitleTop : '' }`}>
                    { pageType === 'delivery'
                        ? (
                            <>
                                <Grid container>
                                    <Grid item xs="6" className={classes.addressSubHeaderMain}>
                                        <Typography className={classes.addressSubHeaderMobile} variant="h5">DELIVERY ADDRESS</Typography>
                                    </Grid>
                                    <Grid item xs="6">
                                        <Button
                                            data-test="checkout-recipient-form-select-from-savedaddress"
                                            key={`il_input_${name}`}
                                            htmlFor={name}
                                            className={pageType === 'pdp' ? classes.btnMyAddressBook : classes.buttonRootClass}
                                            onClick={this.handleOpenAddressBook}
                                        >
                                            {label}
                                        </Button>
                                    </Grid>
                                </Grid>
                                <div className={classes.mobileDividerLine} />
                            </>
                        )
                        :                     (
                            <Button
                                data-test="checkout-recipient-form-select-from-savedaddress"
                                key={`il_input_${name}`}
                                htmlFor={name}
                                // className={classes.buttonRootClass}
                                className={isCCONewCalenadarEnabled && displayDeliveryCalendar && pageType === 'pdp' ? `${classes.ccoNewCalendarBtnMyAddressBook} ${myAddressBook}` : `${pageType === 'pdp' ? `${classes.btnMyAddressBook} ${myAddressBook} ${plaAddressBook}` : classes.buttonRootClass}`}
                                onClick={this.handleOpenAddressBook}
                            >
                                {label}
                            </Button>
                        )}
                </div>
                <Dialog
                    classes={{
                        paper: classes.modalBox,
                    }}
                    open={openAddressBook}
                    onClose={this.handleCloseAddressBook}
                >
                    <Grid container className={classes.fixedHeader}>
                        <Grid container className={classes.modalHeader}>
                            <Typography className={classes.dialogTitle} variant="h6" id="modal-title">
                                Address Book
                            </Typography>
                            <IconButton data-test="checkout-recipient-form-savedAddress-close" className={classes.closeBtn} aria-label="Close" onClick={this.handleCloseAddressBook}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        {
                            contentModalType === 'list'
                                ? (
                                    <Grid container>
                                        <Grid className={classes.addAdressButton} item xs={3}>
                                            <Button
                                                data-test="checkout-recipient-form-list-savedAddress"
                                                classes={{
                                                    root: classes.btnAddAddress,
                                                }}
                                                onClick={() => this.handleAddAddressBook()}
                                            >
                                                + Add New Address
                                            </Button>
                                        </Grid>
                                        <Grid className={classes.searchBlock} item xs={4}>
                                            { /* Search Text Box */  }
                                            <TextField
                                                id="addressBookSearchText"
                                                value={searchText}
                                                className={classes.searchTextBox}
                                                onChange={this.handleSearchTextChange}
                                                placeholder="Search Address"
                                            />
                                        </Grid>
                                        <Grid className={classes.pageCountBlock} item xs={5}>
                                            <Typography className={classes.pageCount} component="div" variant="h6" id="modal-title">
                                                Total ({ totalAddresses }) / Page :  {  this.getPageLink() }
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )
                                : null
                        }
                    </Grid>
                    <Grid className={classes.dialogContent}>
                        { this.getContent() }
                    </Grid>
                </Dialog>
            </Grid>
        );
    }
}

AddressBookWithPagination.propTypes = {
    classes: object.isRequired,
    entries: array,
    label: string,
    name: string.isRequired,
    pageType: string,
    onSelectedAddress: func.isRequired,
    loadAddressBook: func.isRequired,
    handleChangeAddressBook: func.isRequired,
    handleRemoveAddressBook: func.isRequired,
    noOfPages: number.isRequired,
    pageOn: number.isRequired,
    totalAddresses: number.isRequired,
    auth: shape({
        loginByRedirect: func.isRequired,
        getAccessTokenSafely: func.isRequired,
    }).isRequired,
    isAccessBasedOnScopeEnabled: bool,
    isPdpRedesignEnabled: bool,
    displayDeliveryCalendar: bool.isRequired,
    isCCONewCalenadarEnabled: bool.isRequired,
    isPdpDeliveryTopEnabled: bool,
    isPlaRedesignEnabled: bool,
};

AddressBookWithPagination.defaultProps = {
    entries: [],
    label: 'My Address Book',
    pageType: '',
    isAccessBasedOnScopeEnabled: false,
    isPdpRedesignEnabled: false,
    isPdpDeliveryTopEnabled: false,
    isPlaRedesignEnabled: false,
};

export default compose(
    withAuth,
    withStyles(styles),
)(AddressBookWithPagination);
